import * as XLSX from 'xlsx';

import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';

import { mapToAccommodationAnswers } from './mappers/accommodation';
import { mapToBuildingHeatingAnswers } from './mappers/building-heating';
import { mapToCargoAnswers } from './mappers/cargo';
import { mapToCateringBeverageAnswers } from './mappers/cateringBeverage';
import { mapToCateringMealAnswers } from './mappers/cateringMeal';
import { mapToDigitalAnswers } from './mappers/digital';
import { mapToEnergyAnswers } from './mappers/energy';
import { mapToEquipmentAnswers } from './mappers/equipment';
import { mapToGeneratorAnswers } from './mappers/generator';
import { mapToMobilityAnswers } from './mappers/mobility';
import { mapToNonRecyclableWasteAnswers } from './mappers/nonRecyclableWaste';
import { mapToOfficeSuppliesNewAnswers } from './mappers/office-supplies-new';
import { mapToOfficeSuppliesRefurbishAnswers } from './mappers/office-supplies-refurbish';
import { mapToRecyclableWasteAnswers } from './mappers/recyclableWaste';
import { mapToTeamMobilityAnswers } from './mappers/team-mobility';
import { mapToWaterAnswers } from './mappers/water';

export async function convertExcelToImpactAnswers(file: File) {
  const rows = await readTheGreenshotFile(file);
  const answers: ImpactCo2Answer[] = mapImportedRows(rows);
  return answers;
}

export interface ImportedRow {
  Description: string;
  // sector (Artistes Equipe Public Site)
  Sector: string;
  // category (MOBILITY ACCOMMODATION etc...)
  'Fairly Category Description': string;
  // field 1 value : first field of most of questions (mobility transportationMode TRAIN_IN_FRANCE - accommodation accommodationType HOTEL etc...)
  'Fairly Sub Category Description': string;
  // specific field values :
  'Distance (Km)': string; // mobility travelDistance
  'No. Of passengers': string; // mobility passengerCount
  'Number of nights': string; // accommodation numberOfNights
  'Volume (L)': string; // cateringBeverage beverageCount
  Quantity: string; // cateringMeal mealCount
  'Weight (kg)': string; // recyclableWaste recyclableWasteQuantity ...
  'Elec Consumption (kwh)': string; // energy energyConsumptionQuantity
  dataUsage: string; // digital
  videoViews: string; // digital
  rentalDays: string; // equipment
  buildingSize: string; // buildingHeating
  numberOfMonthsOfUse: string; // buildingHeating
}

async function readTheGreenshotFile(file: File) {
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data);
  const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  fixWorksheetRange(worksheet);
  const raw_data: ImportedRow[] = XLSX.utils.sheet_to_json(worksheet, {
    // header: 1 // without this the objet has column names as keys
  });
  return raw_data;
}

function fixWorksheetRange(ws: XLSX.WorkSheet) {
  const range = { s: { r: Infinity, c: Infinity }, e: { r: 0, c: 0 } };
  Object.keys(ws).forEach((cell) => {
    if (cell[0] === '!') return;
    const decoded = XLSX.utils.decode_cell(cell);
    range.s.r = Math.min(range.s.r, decoded.r);
    range.s.c = Math.min(range.s.c, decoded.c);
    range.e.r = Math.max(range.e.r, decoded.r);
    range.e.c = Math.max(range.e.c, decoded.c);
  });
  ws['!ref'] = XLSX.utils.encode_range(range);
}

function mapImportedRows(rows: ImportedRow[]) {
  let responses = [
    ...mapToAccommodationAnswers(rows),
    // ...mapToBuildingAnswers(rows), // not imported
    ...mapToBuildingHeatingAnswers(rows),
    ...mapToCargoAnswers(rows),
    ...mapToCateringBeverageAnswers(rows),
    ...mapToCateringMealAnswers(rows),
    ...mapToDigitalAnswers(rows),
    ...mapToEnergyAnswers(rows),
    ...mapToEquipmentAnswers(rows),
    ...mapToGeneratorAnswers(rows),
    ...mapToMobilityAnswers(rows),
    ...mapToTeamMobilityAnswers(rows),
    ...mapToNonRecyclableWasteAnswers(rows),
    ...mapToOfficeSuppliesNewAnswers(rows),
    ...mapToOfficeSuppliesRefurbishAnswers(rows),
    ...mapToRecyclableWasteAnswers(rows),
    ...mapToWaterAnswers(rows),
  ];
  responses = responses.filter((x) => x.sector !== ''); // remove empty sector
  return responses;
}
